//1. Import
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Navbar from '../modules/Navbar'

//2. Init module
gsap.registerPlugin(ScrollTrigger,ScrollSmoother);
const navbar=new Navbar();
const scroller=ScrollSmoother.create({
	smooth: 1,             // how long (in seconds) it takes to "catch up" to the native scroll position
	effects: true,           // looks for data-speed and data-lag attributes on elements
	smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
});

//3. Variable Declaration
let sectionID=navbar.getSectionId()
let locationsList = document.querySelector(".contact-location");
let locationsListSideTitle = document.querySelector(".contact-location__side-title");
let sectionsSideTitleRightMobile = gsap.utils.toArray('.section-title__side-right--mobile')
let sectionsSideTitleMobile = gsap.utils.toArray('.section-title__side-left--mobile')
let sectionInquiry = document.querySelector(".contact-inquiry");
let inquirySideTitle = document.querySelector(".contact-inquiry__side-title");

//4. Events
window.addEventListener("load", (event) => {
	if(sectionID=='inquiry'){
		navbar.scrollToSection('#inquiry')
	}
	document.querySelector(".wpcf7").addEventListener(
		"wpcf7mailsent",
		function (event) {
			console.log(thankyouUrl);
			location = thankyouUrl;
		},
		false
	);
});

//5. Function
if (locationsList && locationsListSideTitle ) {
	ScrollTrigger.create({
		trigger: '.contact-location__side-title',
		start: '-300px top',
		end: () => `+=${locationsList.offsetHeight - (locationsListSideTitle.offsetWidth+ 180)}`,
		pin: '.contact-location__side-title',
	})
}


if (sectionInquiry && inquirySideTitle ) {
	ScrollTrigger.create({
		trigger: '.contact-inquiry__side-title',
		start: '-300px top',
		end: () => `+=${sectionInquiry.offsetHeight - (inquirySideTitle.offsetWidth+400)}`,
		pin: '.contact-inquiry__side-title',
	})
}


sectionsSideTitleMobile.forEach( function(sectionSideTitleMobile) {
	gsap.to(sectionSideTitleMobile, {
		xPercent: -150,
		ease: "none",
		scrollTrigger: {
			trigger: sectionSideTitleMobile,
			start: "top center",
			end: "bottom top",
			scrub: true,
		}
	})
})


sectionsSideTitleRightMobile.forEach( function(sectionSideTitleRightMobile) {
	gsap.to(sectionSideTitleRightMobile, {
		xPercent: -150,
		ease: "none",
		scrollTrigger: {
			trigger: sectionSideTitleRightMobile,
			start: "top center",
			end: "bottom top",
			scrub: true,
		}
	})
})

